import React from "react";

import DefaultContent from "./DefaultContent.js";
import Navbar from "./Navbar";
import { useSelector } from "react-redux";
import PublicNavbar from "./PublicNavbar.js";
import MustBeLogged from "../../views/user/MustBeLogged.js";

const DefaultLayout = () => {
  const user = useSelector((state) => state.user);
  return (
    <div className="default-layout">
      {user ? <Navbar /> : <PublicNavbar />}

      <div className="container main-content mt-4">
        {user ? <DefaultContent /> : <MustBeLogged />}
      </div>
    </div>
  );
};

export default DefaultLayout;
